import { get } from 'lodash';
import React, { memo, useEffect, useMemo, useState } from 'react'
import { globalHistory } from '@reach/router'
import * as PlansService from '../../shared/services/plans'
import Dialog from '../../components/Dialog';
import * as Styled from './styled'

const INITIAL_TITLE = 'Procedimentos';

const ProceduresListModal = ({ open, onCancel, planCode, isDesk }) => {
  const { location } = globalHistory
  const [selectedProcedure, setSelectedProcedure] = useState();
  const [proceduresType, setProceduresType] = useState([])
  const handleClickArrowBack = useMemo(() =>
    selectedProcedure
      ? () => setSelectedProcedure(null)
      : undefined,
    [selectedProcedure]
  );
  const title = useMemo(() =>
    get(selectedProcedure, 'name', INITIAL_TITLE),
    [selectedProcedure]
  )

  useEffect(() => {
    if (planCode) {
      PlansService.getDetails(planCode)
        .then(result => {
          setProceduresType(result.proceduresType)
        });
    }
  }, [location.hash, planCode]);

  useEffect(() => {
    if (!open) {
      setProceduresType([])
      setSelectedProcedure(null);
    }
  }, [open])

  return (
    <Dialog
      isDesk={isDesk}
      title={title}
      onClose={onCancel}
      open={open}
      onClickArrowBack={handleClickArrowBack}
    >
      <Styled.ProceduresList>
        {selectedProcedure
          ? selectedProcedure.procedures.map(procedure => (
            <li key={procedure.number}>
              {procedure.number} - {procedure.description}
            </li>
          ))
          : proceduresType.map(procedure => (
            <Styled.ProcedureItem
              onClick={() => { setSelectedProcedure(procedure) }}
              key={procedure.name}
            >
              {procedure.name}
            </Styled.ProcedureItem>
          ))}
      </Styled.ProceduresList>
    </Dialog>
  )
}

export default memo(ProceduresListModal)
